import { Component, OnInit, Input } from '@angular/core';

import { FormService } from '@bayclubs/utils';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';

import { ReportsEventService } from '../../reports-event.service';

import { FilterDropDownsService } from '../../../../services/filter-dropdowns.service';
import { TransactionReportFilter } from '../../../../models/filters/reports-filters.model';

@Component({
    selector: 'app-transaction-report-search-criteria',
    templateUrl: './transaction-report-search-criteria.component.html',
    styleUrls: ['./transaction-report-search-criteria.component.scss'],
    standalone: false
})
export class TransactionReportSearchCriteriaComponent implements OnInit {
    @Input()
    public searchForm: UntypedFormGroup;

    public isBusy: boolean = true;
    public campTypeDropdownItems: DropdownMultiselectItem[] = [];
    @Input() public filters : TransactionReportFilter;


    constructor(
        private reportsEvent: ReportsEventService,
        private filterDropDownsService: FilterDropDownsService
    ) {}

    ngOnInit() {
        this.isBusy = true;
        this.initFilters();
    }

    private initFilters(){
        this.campTypeDropdownItems = this.filterDropDownsService.createCampTypeDropDownItems(this.filters.campTypes);
    }

    public onSubmit() {
        this.reportsEvent.onSearch();
    }

    public isFormValid() {
        return FormService.isFormValid(this.searchForm);
    }

    public onCampTypeChanged(data: Array<DropdownMultiselectItem>) {
        const campTypes = data.map(x => x.id);
        this.searchForm.controls['campTypes'].setValue(campTypes);
    }

}
